module.exports = __webpack_public_path__ + "static/media/vip_room_3.d8d758b4.png";